import React from 'react'

export default class extends React.Component {
  static defaultProps = {
    school: {},
    locale: 'fi',
    completePerc: 0,
    loggedOut: false,
    code: ''
  };

  getVerdict = () => {
    if (this.props.completePerc < 50) {
      return null
    }
    if (this.props.completePerc < 65) {
      return ["Not bad", "notbad", "normal"]
    }
    if (this.props.completePerc < 85) {
      return ["Good work!", "good", "happy"]
    }
    return ["Excellent work!", "excellent", "happy super"]
  };

  render() {
    const verdict = this.getVerdict()

    return (
      <section className="thanks">
        <h1>
          {I18N._("Thanks for filling out the form!", this.props.locale)}
        </h1>
        <p>
          {I18N._("You answered {{percent}} of the questions.",
            {
              locale: this.props.locale,
              params: { percent: `${this.props.completePerc}%` }
            }
          )}
        </p>
        <p>
          {I18N._("You can continue where you left off by using your personal code: {{code}}",
            {
              locale: this.props.locale,
              params: { code: this.props.code }
            }
          )}
        </p>
        {
          verdict !== null &&
          <div className="verdict">
            <div className={verdict[2] + " smiley"}>
              <div className="steam-container">
                <div className="squiggle-container squiggle-container-1">
                  <div className="squiggle">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 28.1 80.6"
                      style={{ "enable-background": "new 0 0 28.1 80.6" }} xmlSpace="preserve">
                      <path className="" fill="none" strokeWidth="11" strokeLinecap="round" strokeMiterlimit="10"
                        d="M22.6,75.1c-8-5.6-15.2-10.5-15.2-19.9c0-12.1,14.1-17.2,14.1-29.6c0-9.1-6.7-15.7-16-20.1" />
                    </svg>
                  </div>
                </div>
                <div className="squiggle-container squiggle-container-2">
                  <div className="squiggle">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 28.1 80.6" style={{ "enable-background": "new 0 0 28.1 80.6" }} xmlSpace="preserve">
                      <path className="" fill="none" stroke="#fff" strokeWidth="11" strokeLinecap="round" strokeMiterlimit="10"
                        d="M22.6,75.1c-8-5.6-15.2-10.5-15.2-19.9c0-12.1,14.1-17.2,14.1-29.6c0-9.1-6.7-15.7-16-20.1" />
                    </svg>
                  </div>
                </div>
                <div className="squiggle-container squiggle-container-3">
                  <div className="squiggle">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 28.1 80.6" style={{ "enable-background": "new 0 0 28.1 80.6" }} xmlSpace="preserve">
                      <path className="" fill="none" stroke="#fff" strokeWidth="11" strokeLinecap="round" strokeMiterlimit="10"
                        d="M22.6,75.1c-8-5.6-15.2-10.5-15.2-19.9c0-12.1,14.1-17.2,14.1-29.6c0-9.1-6.7-15.7-16-20.1" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="eyes">
                <div className="eye"></div>
                <div className="eye"></div>
              </div>
              <div className="mouth"></div>
            </div>

            <p className={verdict[1]}>
              {I18N._(verdict[0], { locale: this.props.locale })}
            </p>

            {this.props.loggedOut === true &&
              <p>
                {I18N._("We've logged you out of the service", this.props.locale)}
              </p>
            }
          </div>
        }

        <p>
          <a className="btn btn-lg btn-success" href="/forms">{I18N._("Go back to the beginning", this.props.locale)}</a>
        </p>
        {/*<div className="text-center">*/}
        {/*  <button onClick={() => document.location.reload()}>{I18N._("Back to the beginning")}</button>*/}
        {/*</div>*/}
      </section>
    )
  }
}